import {
BirthdayRewardFormSchema,
  BranchFormSchema,
  CampaignFormSchema,
  CardCategoryFormSchema,
  CardSeriesFormSchema,
CouponFormSchema,
  LevelFormSchema,
  ManualUpgradeFormSchema,
  PersonFormSchema,
ReferralFormSchema,
ReferralSettingFormSchema,
  RegistrationFormSchema,
  ReportFormSchema,
  RequestFormSchema,
  RequestTypeFormSchema,
  RewardEventFormSchema,
  RewardFormSchema,
  RewardTypeFormSchema,
  RoleFormSchema,
SplashScreenFormSchema,
  TenantFormSchema,
  TierLevelFormSchema,
  TransactionFormSchema,
VehicleFormSchema,
VehicleTransactionFormSchema,
// DEFAULT IMPORT ADD
} from "./form.rule";

export const loginFormDefault = {
  username: "",
  password: "",
};
export const tenantFormDefault = {
  owner: "",
  slug: "",
  businessName: "",
  businessType: "",
  description: "",
  avatar: "",
  email: "",
  mobileNumber: "",
  phoneNumber: "",
  website: "",
  membershipDate: "" as any,
  rewardsType: "",
  postRegistrationLink: "",
  postRegistrationMessage: "",
  allowUnderEighteen: false,
  allowDecimalPoints: false,
  featureQuota: false,
  featureSplashScreen: false,
  featureCoupon: false,
  featureReferral: false,
  featureBirthdayEmail: false,
  smtpAppPassword: "",
  smtpMailUser: "",
  smtpMailFrom: "",
  smtpMailContent: "",
  termsAndConditions: "",
  privacyPolicy: "",
} as TenantFormSchema;
export const roleFormDefault = {
  name: "",
  description: "",
} as RoleFormSchema;
export const personFormDefault = {
  tenant: "",
  role: "",
  firstName: "",
  middleName: "",
  lastName: "",
  username: "",
  email: "",
  password: "",
  isVerified: false,
  avatar: "",
  activationCode: "",
  gender: "",
  birthday: "" as any,
  isBlocked: false,
  mobileNumber: "",
  fatherName: "",
  motherName: "",
  emergencyContact_1Number: "",
  emergencyContact_1Name: "",
  emergencyContact_1Relationship: "",
  emergencyContact_2Number: "",
  emergencyContact_2Name: "",
  emergencyContact_2Relationship: "",
  sss: "",
  philhealth: "",
  pagibig: "",
  tin: "",
  medicalCondition: "",
  bloodType: "",
  elementary: "",
  highSchool: "",
  college: "",
  postCollege: "",
  undergraduate: "",
  curriculumVitae: "",
  supportingDoc: "",
  intentLetter: "",
  applicationLetter: "",
  photo: undefined,
  cardCategory: "",
} as PersonFormSchema;
export const rewardFormDefault = {
  tenant: "",
  isPoints: false,
  isStamp: false,
  isLevel: false,
  denominationPoints: 0,
  points: 0,
  denominationStamp: 0,
  stamp: 0,
  isActive: undefined,
} as RewardFormSchema;
export const rewardEventFormDefault = {
  tenant: "",
  name: "",
  description: "",
  isPoints: false,
  isStamp: false,
  isLevel: false,
  denominationPoints: 0,
  points: 0,
  denominationStamp: 0,
  stamp: 0,
  startDate: "" as any,
  endDate: "" as any,
  level: "",
} as RewardEventFormSchema;
export const campaignFormDefault = {
  tenant: "",
  level: "",
  name: "",
  description: "",
  image: "",
  points: 0,
  stamp: 0,
  redeemByPoints: false,
  redeemByStamp: false,
  multiRedeem: false,
  redeemLimit: 0,
  startDate: "" as any,
  endDate: "" as any,
  constraint: undefined,
  limitPerMonth: 0,
  forBirthday: false, 
  birthdayWindowDays: 0,
  file: undefined,
} as CampaignFormSchema;
export const rewardTypeFormDefault = {
  name: "",
  description: "",
  tenant: "",
} as RewardTypeFormSchema;
export const requestTypeFormDefault = {
  name: "",
  description: "",
} as RequestTypeFormSchema;
export const transactionFormDefault = {
  tenant: "",
  branch: "",
  userCode: "",
  cardSeries: "",
  reward: "",
  campaign: "",
  action: "",
  amount: 0,
  points: 0,
  stamp: 0,
  remarks: "",
  branchName: "",
  customerName: "",
  campaignName: "",
  cardAlias: "",
  rewardEventName: "",
  voidedBy: "",
  voidedFirstName: "",
  voidedLastName: "",
  voidedAt: "",
  receiptNumber: "",
} as TransactionFormSchema;
export const branchFormDefault = {
  name: "",
  description: "",
  head: "",
  tenant: "",
} as BranchFormSchema;
export const cardSeriesFormDefault = {
  tenant: "",
  cardCategory: "",
  quantity: 0,
  cardCode: "",
  cardOwner: "",
  pin: 0,
} as CardSeriesFormSchema;
export const levelFormDefault = {
  tenant: "",
  name: "",
  description: "",
  avatar: "",
  points: 0,
  stamp: 0,
  constraint: "",
  file: undefined,
  maxPoints: 0,
  maxStamp: 0,
  maxPointsPerDay: 0,
  maxStampPerDay: 0,
} as LevelFormSchema;
export const cardCategoryFormDefault = {
  name: "",
  description: "",
  tenant: "",
  expirationYears: 0,
} as CardCategoryFormSchema;
export const reportFormDefault = {
  dateFilter: "",
  startDate: "" as any,
  endDate: "" as any,
} as ReportFormSchema;
export const requestFormDefault = {
  tenant: "",
  userCode: "",
  cardSeries: "",
  campaign: "",
  expiration: "",
  status: "",
} as RequestFormSchema;
export const registrationFormDefault = {
  tenant: "",
  branch: "",
  cardCategory: "",
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  birthday: "",
  username: "",
  password: "",
  email: "",
  mobileNumber: "",
  avatar: "",
  expiration: "",
  status: "",
  remarks: "",
  referralCode: "",
  photo: undefined,
} as RegistrationFormSchema;
export const tierLevelFormDefault = {
  tenant: "",
  name: "",
  level: 0,
  minAmount: 0,
  maxAmount: 0,
  description: "",
} as TierLevelFormSchema;
export const splashScreenFormDefault = {
  name: "",
  tenant: "",
  image: "",
  description: "",
  link: "",
} as SplashScreenFormSchema;
export const couponFormDefault = {
  tenant: "",
  name: "",
  description: "",
  couponCode: "",
  validUntil: "",
  level: "",
  purpose: "",
  valueType: "",
  points: 0,
  stamps: 0,
  redeemLimit: 0,
  isUserRedeemable: false,
} as CouponFormSchema;
export const referralSettingFormDefault = {
  tenant: "",
  points: 0,
  stamp: 0,
  referralType: "",
} as ReferralSettingFormSchema;
export const referralFormDefault = {
  tenant: "",
  referrer: "",
  referee: "",
  status: "",
} as ReferralFormSchema;
export const manualUpgradeFormDefault = {
  code: "",
  tenant: "",
  branch: "",
  target_level: "",
} as ManualUpgradeFormSchema;
export const birthdayRewardFormDefault = {
  tenant: "",
  points: 0,
  stamp: 0,
  expiryDays: 0,
} as BirthdayRewardFormSchema;
export const vehicleFormDefault = {
  tenant: "",
  userCode: "",
  plateNumber: "",
  make: "",
  model: "",
  year: 0,
  color: "",
  nickname: "",
  remarks: "",
  avatar: "",
  isBlocked: false,
} as VehicleFormSchema;
export const vehicleTransactionFormDefault = {
  tenant: "",
  vehicle: "",
  transaction: "",
  userCode: "",
} as VehicleTransactionFormSchema;
// DEFAULT ADD
